<template>
  <div>
    <div class="flex justify-center">
      <div class="p-2 w-full sm:w-2/3 xl:w-1/2 text-center">
        <div>
          <p class="font-bold mb-3 mt-2">
            Was Sie für die digitale Unterzeichnung benötigen:
          </p>
          <div class="flex justify-center gap-4 my-4">
            <!-- Phone -->
            <div class="flex items-center space-x-1">
              <PhoneIcon
                class="h-5 w-5"
                style="color: #f9b218"
                aria-hidden="true"
              />
              <span class="text-sm font-semibold text-gray-900">Telefon</span>
            </div>

            <!-- Webcam -->
            <div class="flex items-center space-x-1">
              <VideoCameraIcon
                class="h-5 w-5"
                style="color: #f9b218"
                aria-hidden="true"
              />
              <span class="text-sm font-semibold text-gray-900">Webcam</span>
            </div>

            <!-- Duration -->
            <div class="flex items-center space-x-1">
              <ClockIcon
                class="h-5 w-5"
                style="color: #f9b218"
                aria-hidden="true"
              />
              <span class="text-sm font-semibold text-gray-900"
                >5–10 Minuten</span
              >
            </div>
          </div>
        </div>

        <p class="font-bold mb-3 mt-2">Bereit?</p>
        <div v-if="isGemeinschaftskonto">
          <a
            :href="authUrl"
            target="__blank"
            class="btn btn-primary text-xs m-2"
            >Identifikation Person 1</a
          >
          <a
            :href="authUrl2"
            target="__blank"
            class="btn btn-primary text-xs m-2"
            >Identifikation Person 2</a
          >
        </div>
        <div v-else>
          <a
            :href="authUrl"
            target="__blank"
            class="btn btn-primary text-xs m-2"
            >IDENTIFIKATION STARTEN</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { PhoneIcon, ClockIcon, VideoCameraIcon } from "@heroicons/vue/20/solid";
</script>

<script>
export default {
  props: {
    guid: {
      type: String,
      default: "",
    },
    isGemeinschaftskonto: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    authUrl() {
      return (
        process.env.VUE_APP_BACKEND_DOMAIN + `start-crif.php?guid=${this.guid}`
      );
    },
    authUrl2() {
      return (
        process.env.VUE_APP_BACKEND_DOMAIN +
        `start-crif.php?guid=${this.guid}&gemeinschaftskonto=true`
      );
    },
  },
};
</script>
<style scoped>
p {
  font-size: 14px;
  color: #7a7a7a;
}
</style>
